export default __webpack_public_path__ + "static/media/promo_01.d4982a69.jpg";